module.exports = __webpack_public_path__ + "763091b87590117ad9a68d968e694e3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/en/stingray_classica.jpg
// module id = 856
// module chunks = 0